import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class ChangelogService {

	private url = '/ws/changelog';

	constructor(private http: HttpClient) {
	}

	/**
	 * Récupère le changelog.
	 */
	recupererChangelogs(): Observable<string> {
		return this.http.get(this.url, { responseType: 'text' });
	}
}
